import { type useSortable } from '@dnd-kit/sortable';

import { GripVerticalIcon, MinusIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

import { KanbanColumnHeaderDisplay } from '~/components/KanbanColumnHeaderDisplay';
import { KANBAN_COL_PX } from '~/components/KanbanView/shared/kanbanConstants';
import { KANBAN_COLUMN_HEADER } from '~/constants/testIDs';

const KANBAN_COLUMN_HEADER_VERTICAL_PADDING_INSET_PX = 6;

export type KanbanColumnHeaderProps = {
  onHideColumn?: () => void;
  itemCount: number | undefined;
  label: string;
  id: string;
  color?: string;
  dndListeners?: Partial<Pick<ReturnType<typeof useSortable>, 'listeners'>>;
};

export const KanbanColumnHeader = ({
  onHideColumn,
  itemCount,
  label,
  id,
  color,
  dndListeners,
}: KanbanColumnHeaderProps) => {
  return (
    <div
      className="flex items-center justify-between gap-2"
      data-testid={KANBAN_COLUMN_HEADER}
      style={{
        paddingTop: KANBAN_COL_PX - KANBAN_COLUMN_HEADER_VERTICAL_PADDING_INSET_PX,
        paddingBottom: KANBAN_COL_PX - KANBAN_COLUMN_HEADER_VERTICAL_PADDING_INSET_PX,
        paddingLeft: KANBAN_COL_PX,
        paddingRight: KANBAN_COL_PX,
      }}
    >
      <KanbanColumnHeaderDisplay id={id} label={label} color={color} itemCount={itemCount} />
      <div className="flex items-center gap-2">
        {onHideColumn && (
          <Tooltip label="Hide this column" side="top">
            <IconButton
              adsIcon
              appearance="ghost"
              color="gray"
              icon={MinusIcon}
              label="Hide column"
              size="small"
              onClick={onHideColumn}
            />
          </Tooltip>
        )}
        {dndListeners && (
          <IconButton
            adsIcon
            appearance="ghost"
            className="cursor-grab active:cursor-grabbing"
            color="gray"
            icon={GripVerticalIcon}
            label="Move"
            size="small"
            {...dndListeners}
          />
        )}
      </div>
    </div>
  );
};
